<script setup lang="ts">
import type { Theme } from '@teemill/modules/theme-builder';
import { usePlatform } from '@/services/platform';
import { useBreakpoints } from '@/utils/breakpoints';
import { image } from '@/utils/image';
import { TmlImage } from '@teemill/components';
import { type Ref, computed, inject } from 'vue';

const platform = usePlatform();
const breakpoints = useBreakpoints();

const theme = inject<Ref<Theme>>('theme');

const logo = computed(() => {
  return platform.active.value?.logos.find(
    (logo) =>
      logo.meta.device === (breakpoints.smaller('lg').value ? 'mobile' : 'desktop') &&
      logo.meta.theme === theme?.value.style,
  )?.url;
});
</script>

<template>
  <TmlImage
    v-if="logo"
    :alt="platform.active.value?.name || 'Logo'"
    :src="image(logo).srcset(['webp', 'png', 'jpg'])"
    fit="contain"
  />
</template>
